import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { authInitialState,AuthStore } from './definitions'

export const authSlice = createSlice({
    name: 'authSlice',
    initialState: authInitialState,
    reducers: {
        setAuth: (state, { payload }: PayloadAction<AuthStore>) => ({
            ...payload,
            isNotLogged: false,
        }),
        setNotLogged: (state) => ({
            ...state,
            isAuth: false,
            isNotLogged: true,
            companyId: null,
            personId: null
        }),
    },
})

export const { setAuth, setNotLogged } = authSlice.actions
export default authSlice.reducer
